import { Injectable, NgZone } from '@angular/core';
import { TelecmiCallRequest, TelecmiCallResponse } from '../../models/telecmi';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { API_ENDPOINTS, TELECMI_API_ENDPOINTS } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class TelecmiService {

  constructor(
    private http: HttpClient,
    private ngZone: NgZone
  ) { }
  getIncomingAnsweredCalls(payload: TelecmiCallRequest): Observable<TelecmiCallResponse> {
    return this.http.post<TelecmiCallResponse>(`${environment.apiBaseUrl}/${API_ENDPOINTS.CALL_LIST}${TELECMI_API_ENDPOINTS.INCOMING_ANSWERED}`, payload);
  }
  getIncomingMissedCalls(payload: TelecmiCallRequest) {
    return this.http.post<TelecmiCallResponse>(`${environment.apiBaseUrl}/${API_ENDPOINTS.CALL_LIST}${TELECMI_API_ENDPOINTS.INCOMING_MISSED}`, payload);
  }
  getOutgoingAnsweredCalls(payload: TelecmiCallRequest) {
    return this.http.post<TelecmiCallResponse>(`${environment.apiBaseUrl}/${API_ENDPOINTS.CALL_LIST}${TELECMI_API_ENDPOINTS.OUTGOING_ANSWERED}`, payload);
  }
  // streamCallRecording(fileName: string): Observable<Blob> {
  //   return this.http.get(`${environment.telecmiURL}${TELECMI_API_ENDPOINTS.PLAY_RECORD}?appid=${environment.telecmiAppId}&secret=${environment.telecmiSecret}&file=${fileName}`, { responseType: 'blob' });
  // }
  getAudioPlaybackUrl(fileName: string): string {
    return `${environment.apiBaseUrl}${API_ENDPOINTS.PLAY_AUDIO}/${fileName}`
  }
  prepareTelecmiPayload(page: number = 1, limit: number = 20, startDate: number = getUtcTimestamp(30), endDate: number = getUtcTimestamp()): TelecmiCallRequest {
    return {

      start_date: startDate,
      end_date: endDate,
      page: page,
      limit: limit
    };
  }
}

export function getUtcTimestamp(days: number = 0, inSeconds: boolean = false): number {
  const now = Date.now();
  const daysMs = days * 24 * 60 * 60 * 1000;
  const timestamp = now - daysMs;

  return inSeconds ? Math.floor(timestamp / 1000) : timestamp;
}
